import { Component, Inject, OnInit, AfterViewInit, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContactoDialogComponent } from './contacto-dialog.component';

@Component({
  selector: 'app-membresia-dialog',
  templateUrl: './membresia-dialog.component.html',
  styleUrls: ['./membresia-dialog.component.scss']
})
export class MembresiaDialogComponent implements OnInit, AfterViewInit {
  planActual: string;

  // Establecemos un tamaño máximo para el diálogo
  dialogHeight = 'auto';
  dialogWidth = '90%';
  maxWidth = '1200px';

  constructor(
    public dialogRef: MatDialogRef<MembresiaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    private renderer: Renderer2,
    private dialog: MatDialog
  ) {
    this.planActual = data.planActual;
    // Configuramos el diálogo para que ocupe más espacio en pantalla
    this.dialogRef.updateSize(this.dialogWidth, this.dialogHeight);
    this.dialogRef.updatePosition({ top: '20px' });

    // Configurar para que el diálogo no se cierre al hacer clic fuera
    this.dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    // Al iniciar, aseguramos que el diálogo se muestre con el tamaño adecuado
    setTimeout(() => {
      this.dialogRef.updateSize(this.dialogWidth, this.dialogHeight);
    }, 100);

    // Suscribirse a cambios de tamaño de ventana para ajustar el diálogo
    window.addEventListener('resize', () => {
      this.dialogRef.updateSize(this.dialogWidth, this.dialogHeight);
    });
  }

  ngAfterViewInit(): void {
    // Resaltar las celdas de la columna del plan actual
    this.highlightCurrentPlanColumn();
  }

  /**
   * Resalta las celdas de la columna del plan actual
   */
  highlightCurrentPlanColumn(): void {
    setTimeout(() => {
      const table = document.querySelector('.membresia-table');
      if (table && this.planActual) {
        const rows = table.querySelectorAll('tbody tr');
        const columnIndex = this.getPlanColumnIndex(this.planActual);

        if (columnIndex > 0) {
          rows.forEach(row => {
            const cell = row.querySelector(`td:nth-child(${columnIndex})`);
            if (cell) {
              this.renderer.addClass(cell, `highlighted-${this.planActual.toLowerCase()}`);
            }
          });
        }
      }
    }, 200);
  }

  /**
   * Obtiene el índice de la columna según el plan
   */
  getPlanColumnIndex(plan: string): number {
    switch (plan) {
      case 'LITE': return 2;
      case 'PLUS': return 3;
      case 'PRO': return 4;
      default: return 0;
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  seleccionarPlan(plan: string): void {
    if (plan === this.planActual) {
      this.snackBar.open(`Ya tienes el plan ${plan} activo actualmente`, 'Cerrar', {
        duration: 3000
      });
    } else {
      this.snackBar.open(`Has seleccionado el plan ${plan}. Te contactaremos pronto.`, 'Cerrar', {
        duration: 3000
      });
      // Aquí podríamos enviar la información a un servicio
      this.dialogRef.close({ planSeleccionado: plan });
    }
  }

  contactarActualizacion(): void {
    this.snackBar.open('Nos pondremos en contacto contigo para actualizar tu plan', 'Cerrar', {
      duration: 3000
    });
    this.dialogRef.close({ contactar: true });
  }

  /**
   * Abre el diálogo para contactar vía WhatsApp
   */
  abrirContactoDialog(): void {
    const dialogRef = this.dialog.open(ContactoDialogComponent, {
      width: '550px',
      data: { planActual: this.planActual },
      panelClass: 'contacto-dialog-container',
      disableClose: true
    });
  }
}
